<template>
  <div class="row">
    <!-- BLOCK INI AKAN MENGHANDLE LOAD DATA PERPAGE, DENGAN DEFAULT ADALAH 10 DATA -->
    <div class="col-md-3 mb-2">
      <!-- KETIKA SELECT BOXNYA DIGANTI, MAKA AKAN MENJALANKAN FUNGSI loadPerPage -->
      <select
        class="form-control"
        v-model="meta.per_page"
        @change="loadPerPage"
      >
        <option value="5">
          Tampilkan tiap 5 data
        </option>
        <option value="10">
          Tampilkan tiap 10 data
        </option>
        <option value="25">
          Tampilkan tiap 25 data
        </option>
        <option value="50">
          Tampilkan tiap 50 data
        </option>
        <option value="100">
          Tampilkan tiap 100 data
        </option>
      </select>
    </div>

    <div class="col-md-3 offset-md-6">
      <div class="input-group mb-3">
        <input
          type="text"
          class="form-control"
          @input="search"
          placeholder="Cari berdasarkan Nama Penduduk/NIK"
        >
        <div class="input-group-append">
          <button
            class="btn btn-primary"
            type="button"
          >
            <i class="fa fa-search" />
          </button>
        </div>
      </div>
    </div>
      
    <!-- BLOCK INI AKAN MENGHASILKAN LIST DATA DALAM BENTUK TABLE MENGGUNAKAN COMPONENT TABLE DARI BOOTSTRAP VUE -->
    <div class="col-md-12">
      <!-- :ITEMS ADALAH DATA YANG AKAN DITAMPILKAN -->
      <!-- :FIELDS AKAN MENJADI HEADER DARI TABLE, MAKA BERISI FIELD YANG SALING BERKORELASI DENGAN ITEMS -->
      <!-- :sort-by.sync & :sort-desc.sync AKAN MENGHANDLE FITUR SORTING -->
      <div class="table-responsive">
        <b-table
          striped
          hover
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          show-empty
        >
          <!--
          <template v-slot:cell(nama_pemilik)="row">
            <img
              alt="image"
              :src="(row.item.foto) ? $store.getters.getBaseUrl + '/api/file/' + row.item.foto : require('@/assets/stisla/img/avatar/avatar-1.png')"
              class="rounded-circle my-1"
              width="30"
            >
            <br>
            {{ row.item.nama_pemilik }}
          </template>
          -->

          <template v-slot:cell(desa)="row">
            {{ row.item.desa.nama_desa }}, {{ row.item.desa.kecamatan.nama_kecamatan }}
          </template>

          <template v-slot:cell(no)="row">
            {{ (meta.per_page * (meta.current_page-1)) + row.index + 1 }}
          </template>

          <template v-slot:cell(is_aktif)="row">
            <span
              v-if="row.item.is_aktif === 1"
              class="badge badge-success"
            ><i class="fa fa-check-circle mr-2" />Sudah</span>
            <span
              v-else
              class="badge badge-danger"
            ><i class="fa fa-info-circle mr-2" />Belum</span>
          </template>


          <template v-slot:cell(actions)="row">
            <!-- ini button untuk aksi kelola akun -->
            <button
              v-if="aksi === 'kelolaakun'"
              v-b-tooltip
              class="btn btn-primary btn-sm btn-aksi-edit"
              title="Edit Akun"
              @click="$emit('editAkun', row.item)"
              :data-id="row.item.id_user"
            >
              <i class="fa fa-eye" />
            </button>
            <button
              v-if="aksi === 'kelolaakun'"
              v-b-tooltip
              class="btn btn-warning btn-sm btn-aksi-reset-password"
              title="Reset Password Akun"
              @click="$emit('resetPasswordAkun', row.item)"
              :data-id="row.item.id_user"
            >
              <i class="fa fa-key" />
            </button>
            <button
              v-if="aksi === 'kelolaakun' && row.item.is_disabled === 0"
              v-b-tooltip
              class="btn btn-danger btn-sm btn-aksi-disable"
              title="Disable Akun"
              @click="$emit('disableAkun', row.item)"
              :data-id="row.item.id_user"
            >
              <i class="fa fa-times" />
            </button>
            <button
              v-if="aksi === 'kelolaakun' && row.item.is_disabled === 1"
              v-b-tooltip
              class="btn btn-success btn-sm btn-aksi-enable"
              title="Pulihkan Akun"
              @click="$emit('enableAkun', row.item)"
              :data-id="row.item.id_user"
            >
              <i class="fa fa-check" />
            </button>

                        
            <!-- ini button untuk aksi generate otp -->
            <button
              v-if="aksi === 'generateotp'"
              v-b-tooltip
              class="btn btn-warning btn-sm btn-aksi-generate-otp"
              title="Generate OTP"
              @click="$emit('handleGenerateOtp', row.item)"
              :data-id="row.item.id_user"
            >
              <i class="fa fa-key" />
            </button>
          </template>
        </b-table>
      </div>
      <div
        class="overlay-table-loader"
        v-if="loading"
      >
        <b-spinner
          variant="primary"
          label="Text Centered"
        />
      </div>
    </div>
      
    <!-- BAGIAN INI AKAN MENAMPILKAN JUMLAH DATA YANG DI-LOAD -->
    <div class="col-md-6">
      <p>Menampilkan {{ meta.from }} sampai {{ meta.to }} dari {{ meta.total }} data</p>
    </div>
      
    <!-- BLOCK INI AKAN MENJADI PAGINATION DARI DATA YANG DITAMPILKAN -->
    <div class="col-md-6">
      <!-- DAN KETIKA TERJADI PERGANTIAN PAGE, MAKA AKAN MENJALANKAN FUNGSI changePage -->
      <b-pagination
        v-model="meta.current_page"
        :total-rows="meta.total"
        :per-page="meta.per_page"
        align="right"
        @change="changePage"
        aria-controls="dw-datatable"
      />
    </div>

    <b-modal
      v-model="deleteModal"
      title="Hapus"
    >
      <p>Kamu yakin ingin menghapus data ini?</p>
      <template v-slot:modal-footer>
        <div class="w-100 float-right">
          <b-button
            variant="secondary"
            size="sm"
            @click="deleteModal=false"
          >
            Close
          </b-button>
          <!-- JIKA TOMBOL DELETE DITEKAN, MAKA FUNGSI deleteModalButton AKAN DIJALANKAN -->
          <b-button
            variant="primary"
            size="sm"
            @click="deleteModalButton"
          >
            Delete
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash' //IMPORT LODASH, DIMANA AKAN DIGUNAKAN UNTUK MEMBUAT DELAY KETIKA KOLOM PENCARIAN DIISI

export default {
    //PROPS INI ADALAH DATA YANG AKAN DIMINTA DARI PENGGUNA COMPONENT DATATABLE YANG KITA BUAT
    props: {
        //ITEMS STRUKTURNYA ADALAH ARRAY, KARENA BAGIAN INI BERISI DATA YANG AKAN DITAMPILKAN DAN SIFATNYA WAJIB DIKIRIMKAN KETIKA COMPONENT INI DIGUNAKAN
        items: {
            type: Array,
            required: true
        },
        //FIELDS JUGA SAMA DENGAN ITEMS
        fields: {
            type: Array,
            required: true
        },
        //ADAPUN META, TYPENYA ADALAH OBJECT YANG BERISI INFORMASI MENGENAL CURRENT PAGE, LOAD PERPAGE, TOTAL DATA, DAN LAIN SEBAGAINYA.
        meta: {
            type: Object,
            required: true
        },
        editUrl: {
            type: String,
            default: null
        },
        loading: {
            type: Boolean,
            default: null
        },
        aksi: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            //VARIABLE INI AKAN MENGHADLE SORTING DATA
            sortBy: null, //FIELD YANG AKAN DISORT AKAN OTOMATIS DISIMPAN DISINI
            sortDesc: false, //SEDANGKAN JENISNYA ASCENDING ATAU DESC AKAN DISIMPAN DISINI
            //TAMBAHKAN DUA VARIABLE INI UNTUK MENGHANDLE MODAL DAN DATA YANG AKAN DIHAPUS
            deleteModal: false,
            selected: null
        }
    },
    watch: {
        //KETIKA VALUE DARI VARIABLE sortBy BERUBAH
        sortBy(val) {
            //MAKA KITA EMIT DENGAN NAMA SORT DAN DATANYA ADALAH OBJECT BERUPA VALUE DARI SORTBY DAN SORTDESC
            //EMIT BERARTI MENGIRIMKAN DATA KEPADA PARENT ATAU YANG MEMANGGIL COMPONENT INI
            //SEHINGGA DARI PARENT TERSEBUT, KITA BISA MENGGUNAKAN VALUE YANG DIKIRIMKAN
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        },
        //KETIKA VALUE DARI SORTDESC BERUBAH
        sortDesc(val) {
            //MAKA CARA YANG SAMA AKAN DIKERJAKAN
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        }
    },
    methods: {
        //JIKA SELECT BOX DIGANTI, MAKA FUNGSI INI AKAN DIJALANKAN
        loadPerPage(val) {
            //DAN KITA EMIT LAGI DENGAN NAMA per_page DAN VALUE SESUAI PER_PAGE YANG DIPILIH
            this.$emit('per_page', this.meta.per_page)
        },
        //KETIKA PAGINATION BERUBAH, MAKA FUNGSI INI AKAN DIJALANKAN
        changePage(val) {
            //KIRIM EMIT DENGAN NAMA PAGINATION DAN VALUENYA ADALAH HALAMAN YANG DIPILIH OLEH USER
            this.$emit('pagination', val)
        },
        //KETIKA KOTAK PENCARIAN DIISI, MAKA FUNGSI INI AKAN DIJALANKAN
        //KITA GUNAKAN DEBOUNCE UNTUK MEMBUAT DELAY, DIMANA FUNGSI INI AKAN DIJALANKAN
        //500 MIL SECOND SETELAH USER BERHENTI MENGETIK
        search: _.debounce(function (e) {
            //KIRIM EMIT DENGAN NAMA SEARCH DAN VALUE SESUAI YANG DIKETIKKAN OLEH USER
            this.$emit('search', e.target.value)
        }, 500),

        openDeleteModal(row) {
            this.deleteModal = true
            this.selected = row.item
        },
        deleteModalButton() {
            this.$emit('delete', this.selected)
            this.deleteModal = false
        }
    }
}
</script>